import Vue from "vue";
import dummyCollectionPoint from "./data/collection-point";

import {
  API_ROOT_ANALYTICS,
  analytics,
  enrollment,
  econsent,
  participantStatus,
  withdraw,
  dataCollection,
  recruitment,
  participant,
  progress,
  overall,
  quiz,
  queries,
  activities,
  formStatus,
  queriesTime,
  completion,
  completionParticipant,
  missing,
  participants,
  compliance,
  complianceDetails,
  studyCompliance,
  complianceInsight,
  score,
  nonCompilantActivities,
  patientAnalytics,
  insight,
  asyncInsight,
  getPatientAnalyticsData,
  studyEngagement,
  engagementDetails,
  screenFailure,
  eConsentUplodedData,
  totalQuery,
  totalDataChange,
  retention,
  retentionRate,
  benchMarkStatus,
  telehealthVisitsDuration,
  telehealthVisitsCancelled,
  geodemographiccompliance,
  eDRO,
  recentData,
  expectedData,
  dailySpirometerReading,
  nonComplianceParticipantRetentionrate,
  topReasonsForScreenFailures,
  milestones,
  participantstudy,
  complianceRateOverTime,
  discontinuationactivity,
  otherdiscontinuationreasons,
  sensorCompliance
} from "./urls";

const econsentResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${econsent}`);

const quizResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${quiz}`);

const recruitmentResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${recruitment}`);

const participantStatusResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${participantStatus}`);

const withdrawResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${withdraw}`);

const enrollmentParticipantData = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${recruitment}/${overall}`);

const progressResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${participant}/${progress}`);

const screenFailureAggregation = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${screenFailure}`);

const consentDisposition = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${eConsentUplodedData}`);

const topScreenFailureReason = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${topReasonsForScreenFailures}`);

const dataCollectionQueries = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${queries}`);

const dataCollectionActivities = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${activities}`);

const dataCollectionFormStatus = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${formStatus}`);

const dataCollectionQueriesTime = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${queriesTime}`);

const dataOverallCollection = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${completion}`);

const dataOverallCollectionParticipant = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${completionParticipant}`);

const dataOverallCollectionMissing = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${missing}`);
const participantsResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${participants}`);

const completionAndComplianceResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${studyCompliance}/${compliance}`);

const completionDetails = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${studyCompliance}/${complianceDetails}`);

const graphiccompliance = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${studyCompliance}/${geodemographiccompliance}`, {}, { update: { method: "POST" } });

const patientAnalyticsInsight = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${patientAnalytics}/${insight}`);

const patientAsyncInsight = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${patientAnalytics}/${asyncInsight}`);

const patientAnalyticsData = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${patientAnalytics}{/processId}/${getPatientAnalyticsData}`);

const complianceInsightScore = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${complianceInsight}/${score}`);

const complianceInsightNonCompilantActivities = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${complianceInsight}/${nonCompilantActivities}`);

const dataStudyEngagement = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${studyEngagement}/${engagementDetails}`);

const completionAcitivityResource = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${participant}/${completion}`);
const getBenchmarkDataStatus = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${benchMarkStatus}`);
const totalQueries = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${totalQuery}`);

const dataChanges = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${dataCollection}/${totalDataChange}`);

const dataRetentionRate = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${retention}/${retentionRate}`);

const dataTelehealthVisitsDuration = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${telehealthVisitsDuration}`, {}, { update: { method: "POST" } });

const dataTelehealthVisitsCancelled = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${telehealthVisitsCancelled}`, {}, { update: { method: "POST" } });

const eDROActivities = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${eDRO}/${activities}`);
const participantStudy = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${milestones}`);
const participantStudydata = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${retention}/${participantstudy}`, {}, { update: { method: "POST" } });
const DiscontinuationReasonsdata = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${retention}/${discontinuationactivity}`, {}, { update: { method: "POST" } });
const otherDiscontinuationReasonsdata = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${retention}/${otherdiscontinuationreasons}`, {}, { update: { method: "POST" } });
const callRecentData = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${eDRO}/${recentData}`, {}, { update: { method: "POST" } });

const callExpectedData = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${eDRO}/${expectedData}`, {}, { update: { method: "POST" } });

const callDailySpirometerReading = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${eDRO}/${dailySpirometerReading}`, {}, { update: { method: "POST" } });

const callComplianceRateOverTime = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${complianceRateOverTime}`, {}, { update: { method: "POST" } });

const callNonComplianceParticipantRetentionrate = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${enrollment}/${nonComplianceParticipantRetentionrate}`, {}, { update: { method: "POST" } });

const callSensorCompliance = Vue.resource(`${API_ROOT_ANALYTICS}${analytics}{/studyId}/${studyCompliance}/${sensorCompliance}`, {}, { update: { method: "POST" } });

export function getEconsentVisData(params) {
  return econsentResource.get({ ...params });
}

export function getQuizVisData(params) {
  return quizResource.get({ ...params });
}

export function getRecruitmentVisData(params) {
  return recruitmentResource.get({ ...params });
}

export function getParticipantCompletionVisData(params) {
  return progressResource.get({ ...params });
}

export function getParticipantStatusVisData(params) {
  return participantStatusResource.get({ ...params });
}

export function getWithdrawVisData(studyId) {
  return withdrawResource.get({ studyId });
}

export function getCollectionPointData() {
  return new Promise(resolve => {
    resolve(dummyCollectionPoint);
  });
}

export function getEnrollmentParticipantData(params) {
  return enrollmentParticipantData.get({ ...params });
}

export function getStudyEngagementData(params) {
  return dataStudyEngagement.get({ ...params });
}

export function getQueriesEndpoint(params) {
  return dataCollectionQueries.get({ ...params });
}

export function getActivitiesEndpoint(params) {
  return dataCollectionActivities.get({ ...params });
}

export function getFormStatusEndpoint(params) {
  return dataCollectionFormStatus.get({ ...params });
}

export function getQueriesTimeEndpoint(params) {
  return dataCollectionQueriesTime.get({ ...params });
}

export function getOverallColectionEndpoint(params) {
  return dataOverallCollection.get({ ...params });
}

export function getOverallColectionParticipantEndpoint(params) {
  return dataOverallCollectionParticipant.get({ ...params });
}

export function getOverallColectionMissingEndpoint(params) {
  return dataOverallCollectionMissing.get({ ...params });
}
export function getAllUsers(params) {
  return participantsResource.get({ ...params });
}

export function SiteDataPerformance1(params) {
  return participantStudy.get({ ...params });
}
export function SiteDataPerformancedata(params, data) {
  return participantStudydata.save({ ...params }, data);
}
export function DiscontinuationReasons(params, data) {
  return DiscontinuationReasonsdata.save({ ...params }, data);
}
export function otherDiscontinuationReasons(params, data) {
  return otherDiscontinuationReasonsdata.save({ ...params }, data);
}
export function getCompliance(params) {
  return completionAndComplianceResource.get({ ...params });
}

export function getComplianceTable(params) {
  return completionDetails.get({ ...params });
}

export function getgraphiccompliance(params, data) {
  return graphiccompliance.save({ ...params }, data);
}

export function getPatientAnalyticsInsight(params) {
  return patientAnalyticsInsight.get({ ...params });
}
export function initPatientAsyncInsight(params) {
  return patientAsyncInsight.get({ ...params });
}
export function getPatientAsyncAnalyticsInsight(params) {
  return patientAnalyticsData.get({ ...params });
}

export function getComplianceInsightScore(params) {
  return complianceInsightScore.get({ ...params });
}

export function getComplianceInsightNonCompliantActivities(params) {
  return complianceInsightNonCompilantActivities.get({ ...params });
}
export function getScreenFailureAggregationVisData(params) {
  return screenFailureAggregation.get({ ...params });
}
export function getConsentDispositionVisData(params, body) {
  return consentDisposition.save({ ...params }, body);
}

export function getTopReasonsForScreenFailure(params, body) {
  return topScreenFailureReason.save({ ...params }, body);
}
export function getAcitivityCompletionMetrics(params) {
  return completionAcitivityResource.get({ ...params });
}
export function getDataRetentionRate(params) {
  return dataRetentionRate.get({ ...params });
}

export function getTotalQuery(params) {
  return totalQueries.get({ ...params });
}

export function getDataChange(params) {
  return dataChanges.get({ ...params });
}
export function getBenchmarkStatus(studyId) {
  return getBenchmarkDataStatus.get({ studyId });
}
export function getDataTelehealthVisitsDuration(params, data) {
  return dataTelehealthVisitsDuration.save({ ...params }, data);
}

export function getDataTelehealthVisitsCancelled(params, data) {
  return dataTelehealthVisitsCancelled.save({ ...params }, data);
}
export function getEdroActivities(params) {
  return eDROActivities.get({ ...params });
}

export function getRecentData(params, data) {
  return callRecentData.save({ ...params }, data);
}

export function getExpectedData(params, data) {
  return callExpectedData.save({ ...params }, data);
}

export function getDailySpirometerReading(params, data) {
  return callDailySpirometerReading.save({ ...params }, data);
}

export function getComplianceRateOverTime(params, data) {
  return callComplianceRateOverTime.save({ ...params }, data);
}

export function getNonComplianceRateVSRetentionRate(params, data) {
  return callNonComplianceParticipantRetentionrate.save({ ...params }, data);
}

export function getSensorCompliance(params, data) {
  return callSensorCompliance.save({ ...params }, data);
}
